// src/components/admin/AdminShell.js
import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import AdminOverview from './AdminOverview';
import AdminUsers from './AdminUsers';
import AdminPlans from './AdminPlans';
import AdminCamps from './AdminCamps';
import AdminContent from './AdminContent';
import AdminNotifications from './AdminNotifications';
import AdminAnalytics from './AdminAnalytics';
import AdminAchievements from './AdminAchievements';
import AdminRewards from './AdminRewards';
import AdminLekhi from './AdminLekhi';
import './AdminShell.css';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'users', label: 'Users' },
  { id: 'plans', label: 'Fitness Plans' },
  { id: 'camps', label: 'Camps' },
  { id: 'content', label: 'Admin Content' },
  { id: 'rewards', label: 'Rewards' },
  { id: 'notifications', label: 'Manual Notificatns' },
  { id: 'analytics', label: 'Analytics' },
  { id: 'achievements', label: 'Achievements' },
  { id: 'lekhi', label: 'Lekhi' },
];

export default function AdminShell() {
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  const renderTab = () => {
    switch (activeTab) {
      case 'overview': return <AdminOverview />;
      case 'users': return <AdminUsers />;
      case 'plans': return <AdminPlans />;
      case 'camps': return <AdminCamps />;
      case 'content': return <AdminContent />;
      case 'rewards': return <AdminRewards />;
      case 'notifications': return <AdminNotifications />;
      case 'analytics': return <AdminAnalytics />;
      case 'achievements': return <AdminAchievements />;
      case 'lekhi': return <AdminLekhi />;
      default: return <AdminOverview />;
    }
  };

  return (
    <div className="admin-shell">
      <div className="admin-sidebar">
        <div className="admin-logo">Spocademy<span>Admin</span></div>
        <nav className="admin-nav">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`admin-nav-btn ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
        <button className="admin-logout-btn" onClick={logout}>Logout</button>
      </div>
      <div className="admin-main">
        {renderTab()}
      </div>
    </div>
  );
}